<template>
  <div class="flex" style="border-bottom:1px solid">
    <div class="basic-tab"
         style="border-bottom:0;padding-left:12px"
         :class="{'tab-selected': option.value===tab}"
         v-for="(option, idx) in options"
         :key="`option-${idx}`"
         @click="clickTab(option)">
      {{ option.label }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "tab",
    props: {
      value: {
        type: Number,
        required: false
      },
      options: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        tab: 0
      }
    },
    watch: {
      value(n) {
        this.tab = this.value;
      }
    },
    created () {
      if(this.value) this.tab = this.value;
    },
    computed: {
      tabStyle () {
        return {
          borderBottom: '1px solid'
        }
      }
    },
    methods: {
      clickTab (option) {
        this.tab=option.value;
        this.$emit('update:value', this.tab);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .tab-selected
    /*border-bottom 0*/
    background-color white

</style>
